import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Mail, MapPin } from 'lucide-react';

export const Support = () => {
  return (
    <div className="space-y-6 max-w-3xl">
      {/* Header */}
      <div>
        <h1 className="text-3xl font-bold text-slate-900 dark:text-white font-[Manrope]" data-testid="support-title">
          Support
        </h1>
        <p className="text-slate-500 mt-1">Besoin d'aide ? Contactez-nous</p>
      </div>

      {/* Contact info */}
      <Card className="border-0 shadow-sm" data-testid="contact-card">
        <CardHeader>
          <CardTitle className="font-[Manrope]">Nous contacter</CardTitle>
          <CardDescription>Notre equipe est disponible pour vous aider</CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          {/* Email */}
          <div className="flex items-start gap-4 p-4 bg-slate-50 rounded-xl">
            <div className="p-3 rounded-xl bg-indigo-100">
              <Mail className="w-5 h-5 text-indigo-600" />
            </div>
            <div>
              <h3 className="font-semibold text-slate-900">Email</h3>
              <a href="mailto:info@nerium-lnc.com" className="text-indigo-600 hover:underline">
                info@nerium-lnc.com
              </a>
              <p className="text-sm text-slate-500 mt-1">Reponse sous 24h</p>
            </div>
          </div>

          {/* Address */}
          <div className="flex items-start gap-4 p-4 bg-slate-50 rounded-xl">
            <div className="p-3 rounded-xl bg-amber-100">
              <MapPin className="w-5 h-5 text-amber-600" />
            </div>
            <div>
              <h3 className="font-semibold text-slate-900">Adresse</h3>
              <p className="text-slate-600">
                EduPlan - Programme Partenaires<br />
                Paris, France
              </p>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Quick help */}
      <Card className="border-0 shadow-sm bg-indigo-50">
        <CardContent className="p-6">
          <div className="flex items-start gap-4">
            <div className="p-3 rounded-xl bg-indigo-100">
              <Mail className="w-5 h-5 text-indigo-600" />
            </div>
            <div>
              <h3 className="font-semibold text-slate-900">Besoin d'aide rapide ?</h3>
              <p className="text-slate-600 mt-1">
                Consultez les documents dans l'espace Documents pour trouver des reponses 
                a vos questions frequentes sur les commissions, les ventes et les procedures.
              </p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
